import {
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import React from 'react';

import { colors } from '~/packages/common-frontend/colors';
import { tableHeaderStyle } from '~/packages/common-frontend/styles';

const DEFAULT_ROWS = 6;

interface TableSkeletonProps {
  headers: string[];
  rows?: number;
}
export const TableSkeleton = ({
  headers,
  rows = DEFAULT_ROWS,
}: TableSkeletonProps) => {
  if (headers.length === 0) {
    return <Skeleton h="100px" />;
  }

  return (
    <TableContainer>
      <Table borderWidth="1px" borderColor={colors.gray[200]} my="1.5rem">
        <Thead>
          <Tr>
            {headers.map((header) => (
              <Th key={header} sx={tableHeaderStyle}>
                {header}
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {Array.from({ length: rows }).map((_x, rowIdx) => {
            const rowKey = rowIdx;
            return (
              <Tr key={rowKey}>
                {Array.from({ length: headers.length }).map((_y, colIdx) => {
                  const cellKey = colIdx;
                  return (
                    <Td key={cellKey}>
                      <Skeleton h="48px" />
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </TableContainer>
  );
};
